<template>
  <div class="order-manage-goods-info">
    <block-title class="goods-info-box" :title="title">
      <div>
        <a-row>
          <a-col :span="20">
            <a-radio-group class="order-radio" :value="orderGoodsType" @change="orderGoodsTypeChange($event.target.value)">
              <a-radio
                v-for="item in goodsType"
                :key="item.value"
                :class="orderGoodsType === item.value ? 'radioStyle' : ''"
                :value="item.value"
              >{{item.label}}</a-radio>
            </a-radio-group>
          </a-col>
        </a-row>
        <p v-if="orderGoodsType === goodsTypeKye.MING" class="selectStyle" @click="showChooseGoods">
          <img class="goodsStyle" src="@/assets/img/goods.png" alt="">
          从货品库选择
        </p>
        <div
          v-if="orderGoodsType === goodsTypeKye.MING"
          :class="goodsActive ? 'goodsDetilsStyle' : 'goodsActive goodsDetilsStyle'"
        >
          <!-- <a-button class="goodsSelectStyle" type="primary" @click="showChooseGoods">从货品库选择</a-button> -->
          <a-table
            v-if="tableFlag"
            :columns="tableColm"
            :data-source="goods"
            :pagination="false"
            size="small"
            :locale="{emptyText: '暂未选择货品'}"
            :scroll="{ x: 'calc(600px + 50%)'}"
            class="goods-table"
          >
            <span slot="numberTitle"><span class="titleStyle">*</span>数量</span>
            <span slot="weightTitle"><span v-if="showRequire" class="titleStyle">*</span>总重量(kg)</span>
            <span slot="volumeTitle"><span v-if="showRequire" class="titleStyle">*</span>总体积( M³)</span>
            <span slot="temperatureZoneTitle">温区</span>
            <span slot="shipmentTitle"><span class="titleStyle">*</span>发货地</span>
            <template slot="caozuo" slot-scope="text, rowData, index">
              <span
                v-if="isPretend"
                class="deleteBtn"
                @click="onCopy(index)"
              >复制</span>
              <span class="deleteBtn deleteText" @click="onGoodsDelete(index)">删除</span>
            </template>
            <template slot="number" slot-scope="text, record, index">
              <div>
                <a-form-model-item
                  :rules="goodsTypeRules['number'].RULES"
                  :prop="`${propPrefix}.${index}.number`"
                >
                  <InputNumber
                    v-model.trim="goods[index]['number']"
                    @change="(value) => { changePrice(value, index) }"
                  />
                </a-form-model-item>
              </div>
            </template>
            <template slot="weight" slot-scope="text, record, index">
              <div key="weight">
                <a-form-model-item
                  :rules="goodsTypeRules['weight'].RULES"
                  :prop="`${propPrefix}.${index}.weight`"
                >
                  <InputNumber v-model.trim="goods[index]['weight']" :precision="4" :disabled="!!order.levelParams" suffix="kg" @change="againVerify(`${propPrefix}.${index}.volume`,`${propPrefix}.${index}.weight`)"/>
                </a-form-model-item>
              </div>
            </template>
            <template slot="volume" slot-scope="text, record, index">
              <div key="volume">
                <a-form-model-item
                  :rules="goodsTypeRules['volume'].RULES"
                  :prop="`${propPrefix}.${index}.volume`"
                >
                  <InputNumber v-model.trim="goods[index]['volume']" :precision="4" :disabled="!!order.levelParams" suffix="M³" @change="againVerify(`${propPrefix}.${index}.weight`,`${propPrefix}.${index}.volume`)"/>
                </a-form-model-item>
              </div>
            </template>
            <template slot="goodsValue" slot-scope="text, record, index">
              <div key="goodsValue">
                <InputNumber v-model.trim="goods[index]['goodsValue']" />
              </div>
            </template>
            <template slot="temperatureZone" slot-scope="text, record, index">
              <el-row>
                <el-col :span="goods[index]['temperatureZone'] === '自定义温区' ? 7 : 24">
                  <a-form-model-item
                    :rules="goodsTypeRules['temperatureZone'].RULES"
                    :prop="`${propPrefix}.${index}.temperatureZone`"
                    >
                    <a-select
                      v-model="goods[index]['temperatureZone']"
                      :default-value="text"
                      style="width: 120px"
                      :disabled="!!order.levelParams"
                      @change="(val) => changeTemperature(val, index)"
                    >
                      <a-select-option
                        v-for="(temp, i) in tempratureOption(index)"
                        :key="i"
                        :value="temp.value"
                      >{{temp.label}}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="1" style="min-height: 1px"></el-col>
                <el-col v-if="filterTemper(index)" :span="6">
                  <a-form-model-item
                    :rules="goodsTypeRules['lowtemp'].RULES"
                  >
                    <a-input v-model.number="goods[index]['lowtemp']" :disabled="!!order.levelParams" :max-length="3" type="age" />
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="2">
                  <p class="textIcon">—</p>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="6">
                  <a-form-model-item
                    :rules="goodsTypeRules['hightemp'].RULES"
                  >
                    <a-input v-model.number="goods[index]['hightemp']" :disabled="!!order.levelParams" :max-length="3" type="age" />
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="2">
                  <p class="textIcon">℃</p>
                </el-col>
              </el-row>
            </template>
            <template slot="shipment" slot-scope="text, record, index">
              <a-form-model-item
                :rules="goodsTypeRules['shipment'].RULES"
                :prop="`${propPrefix}.${index}.shipment`"
                >
                <a-select
                  v-model="goods[index]['shipment']"
                  :default-value="text"
                  :disabled="filterSelect(record)"
                  style="width: 120px"
                  option-label-prop="value"
                  @change="(value, option)=>{changeShipment(value, option, index)}"
                >
                  <a-select-option
                    v-for="(temp, i) in filterShipmentList(pretendStation,text, record, index)"
                    :key="i"
                    :disabled="temp.disabled"
                    :value="temp.address"
                  ><p>{{temp.address}}</p><span class="optionStyle">{{temp.msg}}</span></a-select-option>
                </a-select>
              </a-form-model-item>
            </template>
          </a-table>
          <div v-if="goods && goods.length > SHOWLENGTH" class="moreData" @click="goodsActive = !goodsActive">
            <a-icon v-if="!goodsActive" type="down" />
            <a-icon v-else type="up" />
            {{ !goodsActive ? '展开更多货品' : '收起更多货品' }}
          </div>
        </div>
        <div v-else class="goodsTypeStyle">
          <a-table
            :columns="goodsTable"
            :data-source="goods"
            size="small"
            :pagination="false"
            class="goods-table tableStyle"
            :scroll="{ x: 'calc(600px + 50%)'}"
          >
            <span slot="goodsLevelTitle"><span class="titleStyle">*</span>货品三级分类</span>
            <span slot="numberTitle"><span class="titleStyle">*</span>数量</span>
            <span slot="weightTitle"><span v-if="goodsWeight && showRequire" class="titleStyle">*</span>总重量(kg)</span>
            <span slot="volumeTitle"><span v-if="goodsVolume && showRequire" class="titleStyle">*</span>总体积( M³)</span>
            <span slot="temperatureZoneTitle"><span v-if="goodstemperature" class="titleStyle">*</span>温区</span>
            <span slot="shipmentTitle"><span class="titleStyle">*</span>发货地</span>
            <template slot="goodsLevel" slot-scope="text, record, index">
              <a-form-model-item
                :rules="goodsTypeRules['goodsLevel'].RULES"
                :prop="`${propPrefix}.${index}.goodsLevel`"
              >
                <a-cascader
                  v-model="goods[index]['goodsLevel']"
                  :options="order.levelOptions"
                  :allow-clear="false"
                  :field-names="{
                    label: 'name',
                    value: 'name',
                    children: 'children'
                  }"
                  placeholder="请选择"
                  @change="changeSkuRatio(index, 'goodsLevel')"
                />
              </a-form-model-item>
            </template>
            <template slot="temperatureZone" slot-scope="text, record, index">
              <el-row>
                <el-col :span="goods[index]['temperatureZone'] === '自定义温区' ? 9 : 24">
                  <a-form-model-item
                    :rules="goodsTypeRules['temperatureZone'].RULES"
                    :prop="`${propPrefix}.${index}.temperatureZone`"
                    >
                    <a-select
                      v-model="goods[index]['temperatureZone']"
                      :default-value="text"
                      style="width: 120px"
                      @change="(val) => changeTemperature(val, index)"
                    >
                      <a-select-option
                        v-for="(temp, i) in skuTempratureOption(index)"
                        :key="i"
                        :value="temp.value"
                      >{{temp.label}}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="1" style="min-height: 1px"></el-col>
                <el-col v-if="filterTemper(index)" :span="5">
                  <a-form-model-item
                    :rules="goodsTypeRules['lowtemp'].RULES"
                  >
                  <!-- 合同已配置分类，不允许在自定义温区内进行调整时需禁用 -->
                    <a-input v-model.number="goods[index]['lowtemp']" :disabled="skuTemperDisable(index)" :max-length="3" type="age" />
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="2">
                  <p class="textIcon">—</p>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="5">
                  <a-form-model-item
                    :rules="goodsTypeRules['hightemp'].RULES"
                  >
                  <!-- 合同已配置分类，不允许在自定义温区内进行调整时需禁用 -->
                    <a-input v-model.number="goods[index]['hightemp']" :disabled="skuTemperDisable(index)" :max-length="3" type="age" />
                  </a-form-model-item>
                </el-col>
                <el-col v-if="filterTemper(index)" :span="2">
                  <p class="textIcon">℃</p>
                </el-col>
              </el-row>
            </template>
            <template v-for="col in tableInputList" :slot="col" slot-scope="text, record, index">
              <div :key="col">
                <a-form-model-item
                  ref="vailter"
                  :rules="filterRules(col) ? goodsTypeRules[col].RULES : null"
                  :prop="filterRules(col) ? `${propPrefix}.${index}.${col}` : null"
                >
                  <InputNumber
                    v-model.trim="goods[index][col]" 
                    :precision="col === 'weight' || col === 'volume' ? 4 : 3"
                    @blur="changeSkuRatio(index, col)"/>
                </a-form-model-item>
              </div>
            </template>
            <template slot="shipment" slot-scope="text, record, index">
              <a-form-model-item
                :rules="goodsTypeRules['shipment'].RULES"
                :prop="`${propPrefix}.${index}.shipment`"
                >
                <a-select
                  v-model="goods[index]['shipment']"
                  :default-value="text"
                  :disabled="filterSelect(record)"
                  style="width: 120px"
                  option-label-prop="value"
                  @change="(value, option)=>{changeShipment(value, option, index)}"
                >
                  <a-select-option
                    v-for="(temp, i) in filterShipmentList(pretendStation,text, record, index)"
                    :key="i"
                    :disabled="temp.disabled"
                    :value="temp.address"
                  ><p>{{temp.address}}</p><span class="optionStyle">{{temp.msg}}</span></a-select-option>
                </a-select>
              </a-form-model-item>
            </template>
            <template slot="caozuo" slot-scope="text, rowData, index">
              <span
                v-if="index === goods.length - 1"
                class="deleteBtn"
                @click="onGoodsTypeAdd(index)"
              >添加</span>
              <span v-if="goods.length > 1" class="deleteBtn deleteText" @click="onGoodsTypeDelete(index)">删除</span>
            </template>
            <template slot="skuUnit" slot-scope="text, rowData, index">
              <a-input v-model.trim="goods[index].skuUnit" style="margin: -5px 0" />
            </template>
          </a-table>
        </div>
      </div>
    </block-title>
    <ChooseGoods ref="chooseGoods" :is-pretend="isPretend" @change="changeData"></ChooseGoods>
  </div>
</template>

<script>
import moment from 'moment';
import Base from "@/api/base";
import InputNumber from "@/components/form/InputNumber.vue";
import BlockTitle from '@/components/panel/BlockTitle.vue'
import {evil} from '@/utils/util'
import { mapState } from 'vuex'
import {
  goodsTableDetils,
  goodsRules,
  goodsPriceRules,
  goodsTableCar,
  goodsTableSopt,
  goodsTableLine,
  goodsTableType,
} from "../goodsTable.js";
import { getZeroEnd } from "../../api"
import ChooseGoods from "./ChooseGoods";

const standardType = {
    CP001: 'CP001',
    CP002: 'CP002',
    CP003: 'CP003',
    CP004: 'CP004',
}

const TEMPERATURES = [
  {
    value: "常温",
    label: "常温",
  },
  {
    value: "冷藏",
    label: "冷藏",
  },
  {
    value: "冷冻",
    label: "冷冻",
  },
  // {
  //   value: "自定义温区",
  //   label: "自定义温区",
  // },
];
const goodsType = [
  {
    value: 1,
    label: "按货品品类",
  },
  {
    value: 0,
    label: "按货品明细",
  },
];
const goodsTypeKye = {
  PING: 1,
  MING: 0
}
const SHOWLENGTH = 10;

// 产品要素映射
const standardCode = {
  mileage: 'mileage',  // 里程
  carType: 'carType',  // 车型
  volume: 'volume',  // 体积
  warmLayer: 'temperatureZone',  // 温层
  weight: 'weight',  // 重量
  cargoValue: 'goodsValue',  // 货值
  number: 'number',  // 件数
}

// // 需要重新验证表单值
// const revalidate={
//   weight:'volume',
//   volume:'weight',
// }

export default {
  components: {
    InputNumber,
    ChooseGoods,
    BlockTitle,
  },
  model: {
    prop: "goods",
    event: "change",
  },
  props: {
    propPrefix: {
      type: String,
      default: "",
    },
    title: {
      default: "货物信息",
      type: String,
    },
    goods: {
      type: Array,
      required: true,
    },
    orderGoodsType: {
      default: 0,
      type: Number,
    },
    standardIndex: {
      default: '',
      type: String,
    },
    standardList:{
      default: () => {},
      type: Array
    },
    productCode: {
      type: String,
      default: ''
    },
    isPretend: {
      type: Boolean,
      default: false
    },
    pretendStation: {
      type: Array,
      default: () => []
    },
    endStation: {
      type: Object,
      default: () => {}
    },
    isEditPage: {
      type: Boolean,
      default: false
    },
    startNum: {
      type: Array,
      default: () => []
    },
  },
  inject: ['order'],
  data() {
      const numberValidator=(rules, value, callback) => {
        const {skuSumLower,skuSumUpper} = this.orderRules.SKU_RANGE;
        if(this.orderRules.SKU_RANGE){
          if((skuSumLower&&value<=skuSumLower)||(skuSumUpper&&value>skuSumUpper)){
            callback(new Error('请输入正确的数量'));
          }
          callback()
        }
        callback()
      }
    const volumeValidator=(rules, value, callback) => {
        if(this.orderRules.SKU_RANGE){
          const {skuVolumeLower,skuVolumeUpper,skuWeightVolumeRatio} = this.orderRules.SKU_RANGE;
          const path=rules.field.split('.')
          const {weight}=this.goods[path[3]]
          const rule = [Number(weight), '*', skuWeightVolumeRatio, '/', 1000]
          if(value===null || value===undefined ||value===''){
            callback();
          }
          if((skuVolumeLower||skuVolumeUpper)&&(value<=skuVolumeLower||value>skuVolumeUpper)){
            callback(new Error('请输入合理的体积范围区间'));
          }else if(value>evil(rule.join('')) && this.showRequire){
            callback(new Error('请输入合理的体积范围区间'));
          }
          callback()
        }
        callback()
      }
      const weightValidator=(rules, value, callback) => {
        if(this.orderRules.SKU_RANGE){
          const {skuWeightLower = 100,skuWeightUpper = 0,skuWeightVolumeRatio = 20} = this.orderRules.SKU_RANGE;
          const path=rules.field.split('.')
          const {volume}=this.goods[path[3]]
          const rule = [Number(volume), '*', skuWeightVolumeRatio, '*', 1000]
          if(value==='' || value===undefined || value===null){
            callback();
          }
          if((skuWeightLower||skuWeightUpper)&&(value<=skuWeightLower||value>skuWeightUpper)){
            callback(new Error('请输入合理的重量范围区间'));
          }else if(value>evil(rule.join('')) && this.showRequire){
             callback(new Error('请输入合理的重量范围区间'));
          }
          callback()
        }
        callback()
      }
      const validateWeightAndVolumn=(rules,value,callback)=>{
        // 非必填的时候
        if(!this.showRequire){
           const path=rules.field.split('.')
           const {volume,weight}=this.goods[path[3]];
           if(this.isEmpty(volume) && this.isEmpty(weight)){
            callback(new Error('请录入重量或者体积,不可全部为空'));
           }
           callback()
        }
        callback()
      }
    return {
      SHOWLENGTH,
      wrapperCol: 17,
      wrapperColmin: 15,
      goodsCategory: [],
      TEMPERATURES,
      goodsType,
      goodsTableDetils,
      goodsPriceList: [],
      goodsActive: false,
      goodsPriceRules,
      goodsTableType,
      tableInputList: ["number", "weight", "volume", "goodsValue"],
      tableList: {
        CP001: goodsTableCar,
        CP002: goodsTableDetils,
        CP003: goodsTableLine,
        CP004: goodsTableSopt,
      },
      tableTypeList: { // 表头动态要素
        volume: {
          slots: { title: 'volumeTitle' },
          dataIndex: 'volume',
          key: 'volume',
          width: 160,
          scopedSlots: { customRender: 'volume' },
        },
        weight: {
          slots: { title: 'weightTitle' },
          dataIndex: 'weight',
          key: 'weight',
          width: 160,
          scopedSlots: { customRender: 'weight' },
        },
        number: {
          slots: { title: 'numberTitle' },
          dataIndex: 'number',
          key: 'number',
          width: 160,
          scopedSlots: { customRender: 'number' },
        },
        temperatureZone: {
          slots: { title: 'temperatureZoneTitle' },
          dataIndex: 'temperatureZone',
          key: 'temperatureZone',
          scopedSlots: { customRender: 'temperatureZone' },
          width: 200,
        },
        goodsValue: {
          title: '总货值(元)',
          dataIndex: 'goodsValue',
          key: 'goodsValue',
          width: 160,
          scopedSlots: { customRender: 'goodsValue' },
        },
      },
      tableFlag: true,
      standardType,
      goodsVolume: true,  // 是否必填
      goodsWeight: true,
      goodsNumber: true,
      goodstemperature: false,
      detailedWeight: false,
      detailedVolume: false,
      standardCode,
      goodsTypeKye,
      ratioList: [],
      numberValidator,
      volumeValidator,
      weightValidator,
      validateWeightAndVolumn
    };
  },
  computed:{
    ...mapState('orderRules', ['orderRules']),
    tableColm(){
      if(!this.standardList && this.standardList.length <= 0) return []
      // 判断产品类型，动态增加要素
      const table = JSON.parse(JSON.stringify(this.tableList[this.standardIndex]))
      const tableTile = table.map((e) => {
        return e.key
      })
     
      this.standardList.forEach((e)=>{
        if(e.productCode === this.standardIndex){
          const keyArry = Object.keys(this.tableTypeList)
          e.elements.forEach((n)=>{
            if(keyArry.includes(standardCode[n.code]) && !tableTile.includes(standardCode[n.code])){
              table.push(this.tableTypeList[standardCode[n.code]])
            }
            // 合同配置了就要必填的要素
            if(n.code === standardCode.weight){
              this.detailedWeight = true
            }
            if(n.code === standardCode.volume){
              this.detailedVolume = true
            }
          })
        }
      })
      if(this.isPretend && this.pretendStation.length > 1){
        table.splice(2,0,{
          slots: { title: 'shipmentTitle' },
          dataIndex: 'shipment',
          key: 'shipment',
          width: 200,
          maxWidth: 200,
          scopedSlots: { customRender: 'shipment' },
        })
      }
      table.push({
        title: '操作',
        dataIndex: 'caozuo',
        key: 'caozuo',
        width: 160,
        fixed: 'right',
        scopedSlots: { customRender: 'caozuo' },
      })
      return table
    },
    goodsTable(){
      if(!this.standardList && this.standardList.length <= 0) return []
      // 判断产品类型，动态增加要素
      const table = JSON.parse(JSON.stringify(this.goodsTableType))
      const tableTile = table.map((e) => {
        return e.key
      })
     
      this.standardList.forEach((e)=>{
        if(e.productCode === this.standardIndex){
          const keyArry = Object.keys(this.tableTypeList)
          e.elements.forEach((n)=>{
            if(keyArry.includes(standardCode[n.code]) && !tableTile.includes(standardCode[n.code])){
              table.push(this.tableTypeList[standardCode[n.code]])
            }
            // 合同配置了就要必填的要素
            if(n.code === standardCode.weight){
              this.goodsWeight = true
            }
            if(n.code === standardCode.volume){
              this.goodsVolume = true
            }
            if(n.conde === standardCode.warmLayer){
              this.goodstemperature = true
            }
          })
        }
      })
      if(this.isPretend && this.pretendStation.length > 1){
        table.splice(2,0,{
          slots: { title: 'shipmentTitle' },
          dataIndex: 'shipment',
          key: 'shipment',
          width: 200,
          maxWidth: 200,
          scopedSlots: { customRender: 'shipment' },
        })
      }
      table.push({
        title: '操作',
        dataIndex: 'caozuo',
        key: 'caozuo',
        width: 160,
        fixed: 'right',
        scopedSlots: { customRender: 'caozuo' },
      })
      return table
    },
    showRequire(){
      // true 为非必填，false就是必填
      const flag=!(this.orderRules.SKU_RANGE && this.orderRules.SKU_RANGE.ignoreWeightVolume)
      return flag
    },
    goodsTypeRules(){
      return {
        ...goodsRules,
        number:{
          ...goodsRules.number,
          RULES:[
            ...goodsRules.number.RULES,
            {validator:this.numberValidator,trigger: "change"}
          ]
        },
        volume:{
          ...goodsRules.volume,
          RULES:[
            // ...goodsRules.volume.RULES,
            { required: this.showRequire, message: '请输入总体积', trigger: 'change' },
            {validator:this.volumeValidator,trigger: "change"},
            {validator:this.validateWeightAndVolumn,trigger:'change'}
          ]
        },
        weight:{
          ...goodsRules.weight,
          RULES:[
            // ...goodsRules.weight.RULES,
            { required: this.showRequire, message: '请输入总重量', trigger: 'change' },
            {validator:this.weightValidator,trigger: "change"},
            {validator:this.validateWeightAndVolumn,trigger:'change'}
          ]
        }
      }
    },
  },
  watch: {
    standardIndex(){
      this.tableFlag = false
      setTimeout(()=>{
        this.tableFlag = true
      }, 500)
    },
  },
  async created() {
    this.ratioList = this.order.ratioList
  },
  mounted() {},
  methods: {
    isEmpty(value){
      if(value==='' || value===undefined || value===null){
        return true
      }
      return false;
    },
    againVerify(prop){
      this.$emit('afreshVali',prop)
    },
    changeSkuRatio(index, col) {
      const {goodsLevel = [], number, volume, weight} = this.goods[index]
      if(!this.showRequire && col==='weight'){
        this.$emit('afreshVali',`${this.propPrefix}.${index}.volume`)
      }
      if(!this.showRequire && col==='volume'){
        this.$emit('afreshVali',`${this.propPrefix}.${index}.weight`)
      }
      const [, , goodsLevel2] = goodsLevel
      if (col === 'goodsLevel' && goodsLevel?.length) {
        this.goods[index].skuId = this.order.goodLevelSku[goodsLevel2]
        this.goods[index].skuName = goodsLevel2
      }
      if (!this.order.levelParams) {
        return
      }
      if (goodsLevel?.length && number) {
        const ratio = this.ratioList.find(item => item.goodsLevel3Name === goodsLevel2)
        if (ratio && ratio.maxRatio && ratio.minRatio) {
          const maxRatio = Number(ratio.maxRatio)
          const minRatio = Number(ratio.minRatio)
          if (volume && Number(volume) && !weight && col !== 'weight') {
            this.goods[index].weight = ((maxRatio + minRatio) / 2 * Number(volume) * 1000).toFixed(4)
          } else if (weight && Number(weight) && !volume && col !== 'volume') {
            this.goods[index].volume = (Number(weight) / 1000 / ((maxRatio + minRatio) / 2)).toFixed(4)
          }
        }
      }
    },
    filterRules(col){
      return (this.goodsWeight || this.goodsVolume || this.goodstemperature||this.goodsNumber) && (col === this.standardCode.weight || col === this.standardCode.volume || col === this.standardCode.warmLayer||col === this.standardCode.number)
    },
    filterSelect(record){
      return !this.endStation.address || record.skuId === '' || !this.endStation.expectTime
    },
    filterShipmentList(data,text, record){
      let list = JSON.parse(JSON.stringify(data))
      this.goods.forEach((e) => {
        if(e.skuId === record.skuId){
          // 货品选择 多装多卸同一个目的地下相同货品不能选择相同起始地
          // 过滤和当前目的地相同的起始地
          list = list.filter((li) => {
            return li.address !== e.shipment && li.address !== this.endStation.address
          })
          // 发货地时间未选择、发货地时间大于目的地 给红色标记
          list.forEach((res) => {
            if(!res.expectTime){
              res.disabled = true
              res.msg = '时间未选择'
            } else if (moment(res.expectTime).valueOf() > moment(this.endStation.expectTime)){
              res.disabled = true
              res.msg = '发货地时间大于收货地时间'
            } else {
              res.disabled = false
              res.msg = ''
            }
          })
        }
      })
      return list
    },
    async changeShipment(value, option, index){
      
      const data = this.pretendStation.filter((e) => {return e.address === value})
      if(this.productCode === "CP002"){
        const res = await getZeroEnd({
          startCityCode: data[0].cityCode,
          endCityCode: this.endStation.cityCode
        })
        if(!res){
            this.$message.warning('当前区域未开通零担业务')
            this.$set(this.goods[index], 'shipment', '')
        } else {
          let address = ''
          if(data[0].stationFullAddress){
            address = data[0].stationFullAddress
          } else {
            address = `${data[0].provinceName}${data[0].cityName}${data[0].countyName}${data[0].address}`
          }

          this.goods[index].startStationAddress = address
          if(!this.startNum.includes(data[0].address)){
            this.goods[index].orderNo = null
          }
          this.$emit('changeShipment', {
            index: option.key, 
            endData: this.endStation
          })
        }
      } else {
        let address = ''
        if(data[0].stationFullAddress){
          address = data[0].stationFullAddress
        } else {
          address = `${data[0].provinceName}${data[0].cityName}${data[0].countyName}${data[0].address}`
          }
        this.goods[index].startStationAddress = address
        if(!this.startNum.includes(data[0].address)){
          this.goods[index].orderNo = null
        }
        this.$emit('changeShipment', {
          index: option.key, 
          endData: this.endStation
        })
      }
    },
    orderGoodsTypeChange(value) {
      this.$emit("orderGoodsTypeChange", value);
    },
    changeTemperature(value, index) {
      // 合同已配置分类,选择温区“自定义温区”，默认填充温度区间的最小/最大值
      if(value === '自定义温区') {
        const option = this.tempratureOption(index).find(item => item.name === '自定义温区') || {}
        this.goods[index].lowtemp = option.minInterval || ''
        this.goods[index].hightemp = option.maxInterval || ''
      }
    },
    skuTemperDisable(index) {
      if (!this.order.levelParams) {
        return false
      }
      const option = this.tempratureOption(index).find(item => item.name === '自定义温区')
      if (option && !option.canEdit) {
        return true
      }
      return false
    },
    tempratureOption(index) {
      const { levelParams } = this.order
      // 合同未配置分类
      if (!levelParams) {
        return TEMPERATURES
      }
      // 合同已配置分类
      const {ext = {}, goodsLevel = []} = this.goods[index]
      let goodsLevel1; let goodsLevel2; let goodsLevel3
      if (ext.goodsLevel1) {
        goodsLevel1 = ext.goodsLevel1
        goodsLevel2 = ext.goodsLevel2
        goodsLevel3 = ext.goodsLevel3
      } else if (goodsLevel) {
        [goodsLevel1, goodsLevel2, goodsLevel3] = goodsLevel
      }
      if (goodsLevel1) {
        const temprature = levelParams[goodsLevel1]?.[goodsLevel2]?.[goodsLevel3] || []
        const list = []
        temprature.forEach(item => {
          list.push({
            ...item,
            value: item.name,
            label: item.name,
          })
        })
        return list
      }
      return TEMPERATURES
    },
    skuTempratureOption(index) {
      // 没有选择品类返回空
      if (!this.goods[index].goodsLevel) {
        return []
      }
      return this.tempratureOption(index)
    },
    filterTemper(index){
      return this.goods[index].temperatureZone === '自定义温区'
    },
    skuChange(value, index, record) {
      this.goodsCategory.forEach((e) => {
        if (value === e.dictionaryCode) {
          this.goods[index].skuName = e.dictionaryName;
        }
      })
      // 多装多卸 切换货品时验证起始地是否重复，重复清空处理
      if(this.isPretend){
        this.goods.forEach((e, i) => {
          if(i !== index && e.dictionaryCode === record.dictionaryCode && e.shipment === record.shipment){
            this.goods[index].shipment = ''
            this.goods[index].startStationAddress = ''
          }
        })
      }
    },
    changeData(data) {
      let arr = []
      if(this.isPretend){
        arr = [...this.goods];
      }
       
      data.forEach((e) => {
        const isSmallUnit = e.ext?.defaultUnit && e.ext?.defaultUnit === e.ext?.smallUnit;
        const originalVolume = isSmallUnit ? (e.volume / e.ext?.conversionRate).toFixed(3) : e.volume
        const originalWeight = isSmallUnit ? (e.weight / e.ext?.conversionRate).toFixed(3) : e.weight
        arr.push({
          ext: e.ext,
          skuId: e.id,
          skuCode: e.skuCode,
          skuName: e.skuName,
          number: e.number ? e.number : undefined,
          weight: e.number ? originalWeight * (e.number) : undefined,// 默认单位等于零单位时,除转换系数
          originalWeight: e.originalWeight || originalWeight,
          volume: e.number ? originalVolume  * (e.number) : undefined, // 默认单位等于零单位时,除转换系数
          originalVolume: e.originalVolume || originalVolume,
          skuNorms: `${e.norms}/${e.unit}`,
          skuUnit: e.ext?.defaultUnit || e.unit,
          temperatureZone: e.temperatureZone,
          goodsValue: e.goodsPrice,
          shipment: e.shipment || '',
          startStationAddress: e.startStationAddress || '',
          lowtemp: e.minTemperature,
          hightemp: e.maxTemperature,
        });
      });
      const goodsLength = this.goods.length
      this.goods.splice(0, goodsLength)
      this.goods.push(...arr);
      this.goodsPriceList = arr.map((e) => {
        if (e.number > 1) {
          return {
            ...e,
            weight: e.weight / e.number,
            volume: e.volume / e.number,
            goodsValue: e.goodsValue / e.number
          }
        }
        return {...e};
      })
    },
    changePrice(value, index) {
      const { weight, originalVolume, originalWeight, volume, goodsValue } = this.goodsPriceList[index]
      if(this.goodsPriceList[index]) this.goods[index].weight = (value * (originalWeight || weight)).toFixed(3);
      if(this.goodsPriceList[index]) this.goods[index].volume = (value * (originalVolume || volume)).toFixed(3);
      if(this.goodsPriceList[index]) this.goods[index].goodsValue = (value * goodsValue).toFixed(2);
    },
    onCopy(index){
      const data = this.goods[index]
      this.goods.push({
        ...data,
        shipment: '',
        startStationAddress: '',
      });
      this.goodsPriceList.push({
        ...data,
        weight: data.weight / data.number,
        volume: data.volume / data.number,
        goodsValue: data.goodsValue / data.number
      })
    },
    onGoodsDelete(index) {
      this.goods.splice(index, 1);
    },
    isDisabled(code) {
      if(this.isPretend){
        return false
      }
      let res = false;
      this.goods.forEach((e) => {
        if (e.skuId === code) {
          res = true
        }
      })
      return res;
    },
    onGoodsTypeAdd(index) {
      this.goods.push({
        key: `a${index}`,
        skuUnit: "",
        number: "",
        weight: "",
        volume: "",
        temperatureZone: "",
        goodsValue: "",
        shipment: '',
        startStationAddress: '',
      });
    },
    onGoodsTypeDelete(index) {
      this.goods.splice(index, 1);
    },
    showChooseGoods() {
      if(this.isPretend){
        this.$refs.chooseGoods.show();
      } else {
        this.$refs.chooseGoods.show(this.goods);
      }
    },
    init() {
      this.setGoodsCategory();
    },
    async setGoodsCategory() {
      const params = {
        status: 1,
        type: "publicGoods",
      };

      this.goodsCategory = await Base.getDictionary(params);
    },
    handleGoodsCategoryChange() {
      const selectedGoods = this.goodsCategory.find(
        (goods) => goods.dictionaryCode === this.goods.skuId
      );
      this.$emit("change", {
        ...this.goods,
        skuName: selectedGoods.dictionaryName, 
      });
    },
    onAdd() {
      this.$emit("add");
    },
    onDelete() {
      this.$emit("delete");
    },
  },
};
</script>

<style lang="less" scoped>
.order-manage-goods-info {
  display: flex;
  align-items: center;
  margin-top: 20px;
  .order-radio {
    .ant-radio-wrapper {
      margin-right: 23px;
      border-radius: 4px;
      border: 1px solid #E7E9EC;
      height: 40px;
      line-height: 40px;
      padding: 0px 13px 0px 9px;
      &.ant-radio-wrapper-checked {
        border: 1px solid #06B880;
      }
      &:hover {
        border: 1px solid #06B880;
      }
    }
  }
  .goods-info-box {
    flex: 1;
    width: 100%;
    > div {
      padding: 0px 32px;
    }
  }
  .button-box {
    padding: 0 30px 0 80px;
  }
}
.form-item {
  display: flex;
  justify-content: space-between;
  // margin-left: 34.5px;
}
.radioStyle {
  color: #06b880;
}
.title {
  font-weight: bold;
  display: inline-block;
  margin-bottom: 16px;
}
.itemWidth {
  width: 22%;
}
.tr {
  text-align: left;
  margin-top: 10px;
}
.goodsDetilsStyle {
  width: 100%;
  position: relative;
  margin-top: 15px;
  padding-bottom: 30px;
  .goodsSelectStyle {
    margin: 15px 0;
  }
  .moreData {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: #fff;
    font-size: 12px;
    color: #06b880;
    position: absolute;
    bottom: 0;
    &:hover {
      cursor: pointer;
    }
  }
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
  }
  /deep/ .ant-form-explain {
    position: absolute;
  }
}
.goodsTypeStyle {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 30px;
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
  }
  /deep/ .ant-form-explain {
    position: absolute;
  }
}
.deleteBtn {
  color: #06b880;
  font-size: 14px;
  margin-right: 15px;
  text-decoration-line: underline;
  &:hover {
    cursor: pointer;
  }
}
.deleteText{
  color: #F56C6C;
  text-decoration-line: none;
}
.goodsActive {
  max-height: 690px;
  overflow: hidden;
}
.goods-table{
  .ant-input ,/deep/ .ant-select{
    width: 100% !important;
  }
  /deep/ .ant-col {
    width: 100% !important;
  }
  /deep/ .ant-table{
      font-size: 12px !important;
      .ant-table-thead{
          background-color: #f5f5f5;
          .ant-table-column-title{
            font-weight: bold;
          }
      }
  }
}
.titleStyle{
  color: red;
}
.textIcon{
  text-align: center;
  line-height: 40px;
}
.selectStyle{
  color: #06B880;
  margin-bottom: 20px;
  margin-top: 20px;
  &:hover{
    cursor: pointer;
  }
}
.tableStyle{
  ::v-deep .ant-table-tbody>tr>td{
    padding: 16px 5px !important;
  }
}
.goodsStyle{
  width: 20px;
  height: 20px;
}
.optionStyle{
  font-size: 12px;
  color: #F56C6C;
}
/deep/ .ant-table-fixed-right{
  z-index: 100 !important;
}
</style>
